import React from 'react'
import HotelRoutes from 'router/HoteRoutes'

function RootRouter() {
    return (
        <>
            <HotelRoutes />
        </>
    )
}

export default RootRouter
